var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25965_52249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2692 1.13916V43.5128",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5045 22.3259H57.0339",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.053 164.517V188.084",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.858 176.295H176.248",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.771 35.7898C159.386 32.1561 163.656 29.7869 168.473 29.7869C176.431 29.7869 182.87 36.2226 182.87 44.1506C182.87 49.9599 179.411 54.9718 174.433 57.2386",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0527 118.771C72.0492 118.771 80.9636 109.877 80.9636 98.906C80.9636 87.9346 72.0492 79.0405 61.0527 79.0405C50.0562 79.0405 41.1417 87.9346 41.1417 98.906C41.1417 109.877 50.0562 118.771 61.0527 118.771Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.927 65.0754C145.628 52.4431 119.838 48.9575 118.137 61.624C116.436 74.2906 145.149 73.7096 143.368 86.9571C141.587 100.205 113.501 96.0469 115.237 83.1981",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.566 45.9163L133.481 54.0151",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.989 94.8623L126.905 102.961",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.787 113.019C152.344 113.019 169.821 95.5829 169.821 74.0741C169.821 52.5654 152.344 35.1292 130.787 35.1292C109.229 35.1292 91.7524 52.5654 91.7524 74.0741C91.7524 95.5829 109.229 113.019 130.787 113.019Z",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.092 195.272C154.83 191.068 175.266 167.979 175.266 140.129V133.078C144.361 133.078 119.313 158.069 119.313 188.904V195.955",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.055 188.904C133.104 166.18 153.038 150.7 153.038 150.7L125.055 188.904Z",
    fill: "#001B47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.055 188.904C133.104 166.18 153.038 150.7 153.038 150.7",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.313 195.955C88.4073 195.955 63.3588 170.964 63.3588 140.129V133.078C86.0097 133.078 105.51 146.496 114.323 165.815",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.49 188.904C105.441 166.18 85.5074 150.7 85.5074 150.7L113.49 188.904Z",
    fill: "#001B47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.49 188.904C105.441 166.18 85.5074 150.7 85.5074 150.7",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.313 188.904C117.954 146.326 123.286 119.819 123.286 119.819",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.71 188.904C168.531 191.012 173.246 193.745 173.246 196.718C173.246 203.428 149.248 208.872 119.655 208.872C90.0627 208.872 66.0646 203.428 66.0646 196.718C66.0646 193.745 70.7797 191.023 78.6002 188.904",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.86 118.771C128.001 133.819 128.001 148.866 128.001 148.866L131.86 118.771Z",
    fill: "#001B47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.86 118.771C128.001 133.819 128.001 148.866 128.001 148.866",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25965_52249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 210,
    fill: "white",
    transform: "translate(40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvest);
export default __webpack_public_path__ + "static/media/invest.5a23df8ca4abbe22aa90f34cbcaadd5b.svg";
export { ForwardRef as ReactComponent };